import Swal from 'sweetalert2'
import cx from 'classnames'
import withSharedReactContent from '~/common/VndlyAlertReactWrapper'
import styles from './VndlyAlert.module.scss'

const ReactSwal = withSharedReactContent(Swal)
export const BaseAlert = ReactSwal.mixin({
  confirmButtonClass: styles.VndlyAlert_confirmBtn,
  cancelButtonClass: styles.VndlyAlert_cancelBtn,
  customClass: {
    container: styles.VndlyAlert_container,
    popup: styles.VndlyAlert_popup
  },
  onRender: popup => {
    popup.querySelector('.swal2-confirm')?.setAttribute('data-testid', 'confirm-button')
  }
})

export const PleaseContactTheVNDLYSupportTeamMessage =
  'An unexpected error occurred. Please contact the VNDLY support team.'

/**
 * @deprecated This component has been replaced by our new Alert components as part of the DS,
 * Alert Modals: http://storybook.beta.vndly.com/?path=/docs/components-alerts-modals--default-confirmations
 * Alert Toasts: http://storybook.beta.vndly.com/?path=/docs/components-alerts-toasts--info-toast
 */
export const VndlyAlert = {
  toast: {
    success: ReactSwal.mixin({
      toast: true,
      type: 'success',
      position: 'top',
      title: 'Success!',
      showConfirmButton: false,
      timer: process.env.NODE_ENV === 'test' ? 0 : 4000,
      customClass: {
        container: styles.VndlyToast_container,
        popup: cx(styles.VndlyToast_popup, styles.VndlyToast_popup__success),
        title: styles.VndlyToast_title__success,
        icon: styles.VndlyToast_icon
      },
      animation: process.env.NODE_ENV !== 'test'
    }),
    inform: ReactSwal.mixin({
      toast: true,
      type: 'info',
      position: 'top',
      title: 'Acknowledged',
      showConfirmButton: false,
      timer: process.env.NODE_ENV === 'test' ? 0 : 4000,
      customClass: {
        container: styles.VndlyToast_container,
        popup: cx(styles.VndlyToast_popup, styles.VndlyToast_popup__success),
        title: styles.VndlyToast_title__success,
        icon: styles.VndlyToast_icon
      },
      animation: process.env.NODE_ENV !== 'test'
    })
  },

  confirm: {
    deletion: BaseAlert.mixin({
      title: 'Delete? Are you sure?',
      text: "You won't be able to undo this action.",
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: styles.VndlyAlert__danger_confirmBtn,
      confirmButtonText: 'Delete',
      animation: process.env.NODE_ENV !== 'test'
    }),
    submission: BaseAlert.mixin({
      title: 'Submit? Are you sure?',
      text: 'Are you sure you want to submit?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: styles.VndlyAlert__warn_confirmBtn,
      confirmButtonText: 'Submit',
      animation: process.env.NODE_ENV !== 'test'
    }),
    question: BaseAlert.mixin({
      title: 'Are you sure?',
      text: "You won't be able to undo this action.",
      type: 'question',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      animation: process.env.NODE_ENV !== 'test'
    }),
    acknowledgment: BaseAlert.mixin({
      title: 'Something Happened...',
      text: undefined,
      type: 'warning',
      confirmButtonClass: styles.VndlyAlert__warn_confirmBtn,
      confirmButtonText: 'Ok',
      animation: process.env.NODE_ENV !== 'test'
    })
  },

  approval: {
    approve: BaseAlert.mixin({
      title: 'Are you sure you want to Approve?',
      text: "You won't be able to undo this action.",
      type: 'question',
      showCancelButton: true,
      focusCancel: true,
      confirmButtonText: 'Confirm Approval',
      cancelButtonText: 'Cancel',
      animation: process.env.NODE_ENV !== 'test'
    }),
    deny: BaseAlert.mixin({
      title: 'Are you sure you want to Deny Approval?',
      text: "You won't be able to undo this action.",
      type: 'warning',
      showCancelButton: true,
      focusCancel: true,
      confirmButtonClass: styles.VndlyAlert__danger_confirmBtn,
      confirmButtonText: 'Deny Approval',
      cancelButtonText: 'Cancel',
      animation: process.env.NODE_ENV !== 'test'
    }),
    renotifyApprovers: BaseAlert.mixin({
      title: 'Are you sure you want to renotify approvers?',
      type: 'warning',
      showCancelButton: true,
      focusCancel: true,
      confirmButtonText: 'Renotify Approvers',
      cancelButtonText: 'Cancel',
      animation: process.env.NODE_ENV !== 'test'
    })
  },

  invalidError: BaseAlert.mixin({
    title: 'Error',
    text: '',
    type: 'error',
    allowOutsideClick: false,
    animation: process.env.NODE_ENV !== 'test'
  }),

  unexpectedError: BaseAlert.mixin({
    title: 'Error',
    text: PleaseContactTheVNDLYSupportTeamMessage,
    type: 'error',
    allowOutsideClick: false,
    animation: process.env.NODE_ENV !== 'test'
  }),

  success: BaseAlert.mixin({
    title: 'Success',
    type: 'success',
    allowOutsideClick: false,
    animation: process.env.NODE_ENV !== 'test'
  }),

  settings: {
    modifyDefaults: BaseAlert.mixin({
      title: 'Are you sure?',
      text: 'Are you sure, you want to modify the default settings?',
      showCancelButton: true,
      focusCancel: true,
      showCloseButton: true,
      allowOutsideClick: true,
      confirmButtonClass: styles.VndlyAlert_confirmBtn,
      cancelButtonClass: styles.VndlyAlert_cancelBtn,
      padding: '2em',
      customClass: {
        container: styles.VndlyAlert_container,
        popup: cx(styles.VndlyAlert_popup, styles.SettingsPopup),
        header: styles.SettingsHeader,
        title: styles.SettingsTitle,
        closeButton: styles.SettingsCloseButton
      },
      animation: process.env.NODE_ENV !== 'test'
    })
  }
}
